<p-toast />
<p-confirmDialog />
<div class="px-6 py-4 form-container">
  <div class="flex justify-content-between">
    <p class="text-xl font-semibold">{{ 'layout.configurations.category.title' | translate }}</p>
    <p-button *emPermission="Permission.CONFIG_BSA" class="p-button-success" icon="pi pi-plus" severity="success"
      (onClick)="onAdd()"></p-button>
  </div>
  <div class="flex justify-content-between mb-4">
    <p-multiSelect [options]="cols" [(ngModel)]="selectedColumn" optionLabel="header" [style]="{ 'min-width': '200px' }"
      [placeholder]="'layout.configurations.category.chooseColums' | translate"
      [selectedItemsLabel]="'{0} ' + ('layout.configurations.category.itemsSelected' | translate)"
      (ngModelChange)="saveSelectedColumn()">
    </p-multiSelect>

    <div class="flex flex-row-reverse flex-wrap gap-3">
      <button pButton [label]="'layout.configurations.category.clear' | translate" class="p-button-outlined"
        icon="pi pi-filter-slash" (click)="clearFilters()"></button>
      <button pButton [label]="'layout.configurations.category.filter' | translate" class="p-button" icon="pi pi-filter"
        style="margin-right: 10px" (click)="toggleFilterLabels()"></button>
    </div>
  </div>
  <div class="table-container">
    <p-table [value]="filteredCategories" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 20, 50, 100]"
      paginatorPosition="bottom" paginatorAlignment="center" styleClass="w-full p-datatable-sm"
      [resizableColumns]="true">
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn scope="col" pSortableColumn="categoryMappingsId.level"
            class="bg-white whitespace-nowrap px-4 py-2">
            {{ 'layout.configurations.category.level' | translate }} <p-sortIcon field="categoryMappingsId.level" />
          </th>
          <th pResizableColumn scope="col" pSortableColumn="careerPath.name"
            class="bg-white whitespace-nowrap px-4 py-2">
            {{ 'layout.configurations.category.careerPath' | translate }}
            <p-sortIcon field="careerPath.name" />
          </th>
          <th pResizableColumn scope="col" pSortableColumn="categoryMappingsId.division"
            class="bg-white whitespace-nowrap px-4 py-2">
            {{ 'layout.configurations.category.division' | translate }} <p-sortIcon
              field="categoryMappingsId.division" />
          </th>
          <th pResizableColumn scope="col" pSortableColumn="categoryMappingsId.categoryShortLabel"
            class="bg-white whitespace-nowrap px-4 py-2">
            {{ 'layout.configurations.category.shortLabel' | translate }} <p-sortIcon
              field="categoryMappingsId.categoryShortLabel" />
          </th>
          <th pResizableColumn scope="col" pSortableColumn="categoryLongLabel"
            class="bg-white whitespace-nowrap px-4 py-2">
            {{ 'layout.configurations.category.longLabel' | translate }} <p-sortIcon field="categoryLongLabel" />
          </th>
          <th pResizableColumn scope="col" pSortableColumn="careerPath.practice"
            class="bg-white whitespace-nowrap px-4 py-2">
            {{ 'layout.configurations.category.practice' | translate }}
            <p-sortIcon field="careerPath.practice" />
          </th>
          <th *ngFor="let col of selectedColumn" pSortableColumn="{{ col.field }}" [ngStyle]="col.style"
            class="bg-white whitespace-nowrap px-4 py-2">
            {{ col.header }}
            <p-sortIcon [field]="col.field" />
          </th>
          <th pResizableColumn scope="col" pSortableColumn="archived" class="bg-white whitespace-nowrap px-4 py-2">
            {{ 'layout.configurations.category.archived' | translate }} <p-sortIcon field="archived" />
          </th>
          <th *emPermission="Permission.CONFIG_BSA" pResizableColumn scope="col" class="bg-white w-10rem pl-3">
            {{ 'layout.configurations.category.actions' | translate }}
          </th>
        </tr>
        <tr *ngIf="showFilterLabels" class="filters">
          <!-- Level -->
          <th scope="col">
            <div class="flex align-items-center filter-container">
              <p-dropdown [(ngModel)]="filters['categoryMappingsId.level']" [options]="levels" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.level' | translate" appendTo="body" [showClear]="false">
                <ng-template let-option pTemplate="level">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <button *ngIf="filters['categoryMappingsId.level'] != null" pButton
                class="p-column-filter-clear-button p-link hover:text-gray-700 hover:bg-gray-100"
                icon="pi pi-filter-slash" (click)="clearFilters('categoryMappingsId.level')"></button>
            </div>
          </th>
          <!-- Career Path -->
          <th scope="col">
            <div class="flex align-items-center filter-container">
              <p-dropdown [(ngModel)]="filters['categoryMappingsId.careerPathId']" [options]="careerPaths"
                (onChange)="setCareerPathFilter($event)" optionLabel="name"
                [placeholder]="'layout.configurations.category.careerPath' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="careerPath">
                  {{ option.name }}
                </ng-template>
              </p-dropdown>
              <button *ngIf="filters['categoryMappingsId.careerPathId'] != null" pButton
                class="p-column-filter-clear-button p-link hover:text-gray-700 hover:bg-gray-100"
                icon="pi pi-filter-slash" (click)="clearFilters('categoryMappingsId.careerPathId')"></button>
            </div>
          </th>
          <!-- Division -->
          <th scope="col">
            <div class="flex align-items-center filter-container">
              <p-dropdown [(ngModel)]="filters['categoryMappingsId.division']"
                [options]="categoryMappingsOptions.divisions" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.division' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="division">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <button
                *ngIf="filters['categoryMappingsId.division'] != null && filters['categoryMappingsId.division'] != ''"
                pButton class="p-column-filter-clear-button p-link hover:text-gray-700 hover:bg-gray-100"
                icon="pi pi-filter-slash" (click)="clearFilters('categoryMappingsId.division')"></button>
            </div>
          </th>
          <!-- Short Label -->
          <th scope="col">
            <div class="flex align-items-center filter-container">
              <input pInputText type="text" [(ngModel)]="filters['categoryMappingsId.categoryShortLabel']"
                (input)="onFilter()" />
              <button *ngIf="
                  filters['categoryMappingsId.categoryShortLabel'] != null &&
                  filters['categoryMappingsId.categoryShortLabel'] != ''
                " pButton class="p-column-filter-clear-button p-link hover:text-gray-700 hover:bg-gray-100"
                icon="pi pi-filter-slash" (click)="clearFilters('categoryMappingsId.categoryShortLabel')"></button>
            </div>
          </th>
          <!-- Long Label -->
          <th scope="col">
            <div class="flex align-items-center filter-container">
              <input pInputText type="text" [(ngModel)]="filters['categoryLongLabel']" (input)="onFilter()" />
              <button *ngIf="filters['categoryLongLabel'] != null && filters['categoryLongLabel'] != ''" pButton
                class="p-column-filter-clear-button p-link hover:text-gray-700 hover:bg-gray-100"
                icon="pi pi-filter-slash" (click)="clearFilters('categoryLongLabel')"></button>
            </div>
          </th>
          <!-- Practice -->
          <th scope="col">
            <div class="flex align-items-center filter-container">
              <p-dropdown [(ngModel)]="filters['careerPath.practice']" [options]="practices" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.practice' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="practice">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <button *ngIf="filters['careerPath.practice'] != null && filters['careerPath.practice'] != ''" pButton
                class="p-column-filter-clear-button p-link hover:text-gray-700 hover:bg-gray-100"
                icon="pi pi-filter-slash" (click)="clearFilters('careerPath.practice')"></button>
            </div>
          </th>

          <!-- optional columns -->
          <th *ngFor="let col of selectedColumn" scope="col">
            <div class="flex align-items-center filter-container">
              <p-dropdown *ngIf="col.field === 'geoCountry'" [(ngModel)]="filters[col.field]" [options]="countries"
                (onChange)="onFilter()" [placeholder]="'layout.configurations.category.geoCountry' | translate"
                appendTo="body" [showClear]="false">
                <ng-template let-option pTemplate="country">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <!-- Professional Categorization -->
              <p-dropdown *ngIf="col.field === 'professionalCategorization'" [(ngModel)]="filters[col.field]"
                [options]="categoryMappingsOptions.professionalCategories" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.professionalCategorization' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="professionalCategorization">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <!-- Business Unit -->
              <p-dropdown *ngIf="col.field === 'businessUnit'" [(ngModel)]="filters[col.field]"
                [options]="categoryMappingsOptions.businessUnits" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.businessUnit' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="businessUnit">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <!-- Division -->
              <p-dropdown *ngIf="col.field === 'categoryMappingsId.division'" [(ngModel)]="filters[col.field]"
                [options]="categoryMappingsOptions.divisions" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.division' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="division">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <!-- Talent Family -->
              <p-dropdown *ngIf="col.field === 'talentFamily'" [(ngModel)]="filters[col.field]"
                [options]="categoryMappingsOptions.talentFamilies" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.talentFamily' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="talentFamily">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <!-- E&L Talent Segment -->
              <p-dropdown *ngIf="col.field === 'elTalentSegment'" [(ngModel)]="filters[col.field]"
                [options]="categoryMappingsOptions.talentSegments" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.elTalentSegment' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="elTalentSegment">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <!-- Job Role -->
              <p-dropdown *ngIf="col.field === 'jobRole'" [(ngModel)]="filters[col.field]"
                [options]="categoryMappingsOptions.jobRoles" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.jobRole' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="jobRole">
                  {{ option }}
                </ng-template>
              </p-dropdown>
              <!-- Is Supervisor -->
              <p-dropdown *ngIf="col.field === 'supervisor'" [(ngModel)]="filters[col.field]"
                [options]="archivedOptions" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.isSupervisor' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="supervisor">
                  <p-tag [value]="option.label" [severity]="option.severity" />
                </ng-template>
              </p-dropdown>
              <input *ngIf="col.field === 'group1' || col.field === 'group2'" pInputText type="text"
                [(ngModel)]="filters[col.field]" (input)="onFilter()" />
              <button *ngIf="filters[col.field] != null && filters[col.field] != ''" pButton
                class="p-column-filter-clear-button p-link hover:text-gray-700 hover:bg-gray-100"
                icon="pi pi-filter-slash" (click)="clearFilters(col.field)"></button>
            </div>
          </th>
          <!-- Archived -->
          <th scope="col">
            <div class="flex align-items-center filter-container">
              <p-dropdown [(ngModel)]="filters['archived']" [options]="archivedOptions" (onChange)="onFilter()"
                [placeholder]="'layout.configurations.category.archived' | translate" appendTo="body"
                [showClear]="false">
                <ng-template let-option pTemplate="archived">
                  <p-tag [value]="option.label" [severity]="option.severity" />
                </ng-template>
              </p-dropdown>
              <button *ngIf="filters['archived'] != null && filters['archived'] != ''" pButton
                class="p-column-filter-clear-button p-link hover:text-gray-700 hover:bg-gray-100"
                icon="pi pi-filter-slash" (click)="clearFilters('archived')"></button>
            </div>
          </th>
          <th scope="col" class="action-th action-filter"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-category>
        <tr [ngClass]="category.archived && 'disabled-row'">
          <td class="px-4 py-2">{{ category.categoryMappingsId.level }}</td>
          <td class="px-4 py-2">{{ category.careerPath.name }}</td>
          <td class="px-4 py-2">{{ category.categoryMappingsId.division }}</td>
          <td class="px-4 py-2">{{ category.categoryMappingsId.categoryShortLabel }}</td>
          <td class="px-4 py-2">{{ category.categoryLongLabel }}</td>
          <td class="px-4 py-2">{{ category.careerPath.practice }}</td>
          <td *ngFor="let col of selectedColumn" class="px-4 py-2">
            <p-tag *ngIf="col.field === 'supervisor'; else defaultCell"
              [value]="getTranslatedValue(category.supervisor)"
              [severity]="category.supervisor ? 'success' : 'danger'"></p-tag>
            <!-- ✅ FIX: was category.isSupervisor (undefined) → now category.supervisor -->
            <ng-template #defaultCell>{{ getCategoryField(category, col.field) }}</ng-template>
          </td>
          <td class="px-4 py-2">
            <p-tag [value]="getTranslatedValue(category.archived)"
              [severity]="category.archived ? 'success' : 'danger'"></p-tag>
          </td>
          <ng-container *emPermission="Permission.CONFIG_BSA">
            <td class="px-4 py-2 flex flex-row-reverse flex-wrap gap-2">
              <p-button icon="pi pi-pencil" [outlined]="true" class="mr-2" (onClick)="onEdit(category)"
                [disabled]="category.archived"></p-button>
              <p-button icon="pi pi-trash" severity="danger" [outlined]="true"
                (onClick)="onDelete($event, category.categoryMappingsId)" [disabled]="category.archived"></p-button>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>